export interface FeatureItem {
  title: string;
  description: string;
  highlights: string[];
  color: string;
}

export const features: FeatureItem[] = [
  {
    title: 'Natural Language Analytics',
    description:
      'Ask questions in plain English. ToStructure generates SQL, queries your databases, and returns insights with zero coding required.',
    highlights: ['Auto SQL Generation', 'Smart Error Retry', 'Large Dataset Support'],
    color: '#2563eb',
  },
  {
    title: 'Drag & Drop Files',
    description:
      'Drop a CSV, Excel, or Parquet file straight into the chat. The AI imports it instantly and can query, analyze, and visualize it on the spot.',
    highlights: ['CSV / Excel / Parquet', 'Instant Import', 'Zero Config'],
    color: '#14b8a6',
  },
  {
    title: 'Multi-Database Support',
    description:
      'Connect to PostgreSQL, MySQL, SQL Server, Snowflake, Databricks, BigQuery, and SQLite from one unified interface.',
    highlights: ['7+ Database Types', 'Secure Connections', 'Schema-Aware Queries'],
    color: '#8b5cf6',
  },
  {
    title: 'Professional Visualizations',
    description:
      'AI-generated charts powered by Highcharts. Bar, line, area, pie, scatter, and more with full customization and one-click PNG export.',
    highlights: ['Highcharts Engine', '8+ Chart Types', 'Export to PNG'],
    color: '#10b981',
  },
  {
    title: 'Multi-AI Provider',
    description:
      'Switch between Anthropic Claude, OpenAI GPT, and DeepSeek or run fully local with LM Studio and Ollama. Your data, your choice.',
    highlights: ['Claude & GPT', 'Local Models', 'Mid-Session Switching'],
    color: '#f59e0b',
  },
  {
    title: 'Citation-Ready Answers',
    description:
      'Every insight is traceable. Automatic APA, MLA, and Chicago citations with full source tracking across data queries and web research.',
    highlights: ['APA / MLA / Chicago', 'Source Tracking', 'Audit Ready'],
    color: '#ec4899',
  },
  {
    title: 'Real-Time Transparency',
    description:
      'Watch the AI think. Live streaming shows SQL execution, web searches, and chart generation as they happen. Full visibility into every step.',
    highlights: ['Thinking Logs', 'Live Streaming', 'Step-by-Step'],
    color: '#06b6d4',
  },
];